import {
    Component,
    OnInit,
  } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { arrayUnion, updateDoc } from "firebase/firestore";
  import { NGXLogger } from "ngx-logger";
  import { MenuItem, MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { PreventivoFase1DTO } from "src/app/models/dto/preventivoFase1.model";
import { SopralluogoFase1DTO } from "src/app/models/dto/sopralluogoFase1.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { PraticheScuolaService } from "src/app/services/pratiche.scuola.service";
import { PraticheService } from "src/app/services/pratiche.service";
import { environment } from "src/environments/environment";

  

@Component({
    selector: "component-carica-planimetria_fase3",
    templateUrl: "./dialog-carica-planimetria.component.html",
    styleUrls: ["../fase3.bando2.component.css"],
  })
  export class DialogCaricaPlanimetriaFase3 implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected pratica: PraticaFlowdy2_Firestore;
    protected selectedFile: File = null;
    protected isFileUploaded: boolean = false;
    protected isLoadingResults: boolean = false;

    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private googleStorageService: GoogleStorageService,
      private messageService: MessageService,
      public firestore: AngularFirestore,
    ) {
      this.pratica          = this.config.data.pratica;
      
    }
  
    ngOnInit(): void {
    }

    
    onFileUpload($event) {
      this.isFileUploaded = true;
      this.selectedFile = $event.files[0];
    }
    onFileRemove() {
      this.isFileUploaded = false;
    }
   
    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {
        const fileExtension = this.selectedFile.name.substring(
          this.selectedFile.name.lastIndexOf(".") + 1
        );
        let fileName:string = this.pratica.cui + "/IN/FASE_3/PLANIMETRIA_"+ this.pratica.cui + "."+fileExtension;
       this.isLoadingResults = true;
  
        this.googleStorageService
          .uploadFileScuolaToGoogleStorage(this.selectedFile, fileName)
          .then((uploadRes) => {
            this.isLoadingResults = false;

            this.dialogRef.close({ success: true, fileExtension: fileExtension });
          })
          .catch((errore) => {
            this.isLoadingResults = false;
            this.messageService.add({
              severity: "info",
             summary: "Errore" , life:10000,
              detail: "Errore in fase di caricamento File!",
            });
  
            this.dialogRef.close({ success: false });
          });
       
      } 
    }
  
  }